<div class="NotificationMessage">
    <div [ngClass]="applyClass()">
        <div class="bx">
            <i class="fa-solid fa-triangle-exclamation"></i>
            {{ notificationMessage.get(type)! | translate }}
        </div>
        <div id="btnCloseNotify" (click)="closeNotification()"><i class="fa-solid fa-circle-xmark"></i></div>
    </div>
</div>
